import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=e6f9789e&scoped=true&"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=e6f9789e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f9789e",
  null
  
)

export default component.exports